@if (
  {
    resources: resources$ | async,
    isLoading: isLoading$ | async,
    currentError: currentError$ | async,
    paginationData: paginationData$ | async,
    onGlobalRefresh: onGlobalRefresh$ | async
  };
  as STATE
) {
  <section class="competing-ads-list-page">
    <page-header />

    <search-bar
      [count]="STATE.resources?.length"
      [searchPlaceholder]="'Rechercher un élément ici'"
      [allowExportButton]="true"
      filterName="ads"
      [allowAddButton]="false"
    >
    </search-bar>
    @if (!STATE.isLoading && !STATE.currentError) {
      <competing-ads-datatable />
      <mat-paginator
        *ngIf="STATE.resources && STATE.paginationData as pagination"
        (page)="handlePageEvent($event)"
        [length]="pagination.fullyItems"
        [pageIndex]="
          STATE.resources && pagination.page ? pagination.page - 1 : 0
        "
        [pageSizeOptions]="[10, 25, 50]"
        [pageSize]="pagination.itemPerPage"
      >
      </mat-paginator>
    }

    @if (STATE.isLoading || STATE.currentError) {
      <loading-or-error
        (retry)="refreshData()"
        [error$]="currentError$"
        spinnerSize="lg"
      ></loading-or-error>
    }
  </section>
}
